exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-top[data-v-11a3b220] {\n  position: absolute;\n  top: 64px;\n  z-index: 100;\n  border-radius: 0;\n  margin-left: 5px;\n  width: calc(100% - 10px);\n}\n.notification-item[data-v-11a3b220] {\n  margin-right: 4rem !important;\n}\n.danger-notification-icon[data-v-11a3b220] {\n  width: 28px;\n  height: 28px;\n  line-height: 32px;\n  margin: 0px;\n  margin-right: 15px;\n}\n.warning-notification-icon[data-v-11a3b220] {\n  width: 30px;\n  height: 30px;\n  margin: 0px;\n  margin-right: 15px;\n}\n.info-notification-icon[data-v-11a3b220] {\n  width: 28px;\n  height: 28px;\n  margin: 0px;\n  margin-right: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11a3b220","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/notification-container/NotificationContainer.vue
// module id = 659
// module chunks = 1